module.exports = __webpack_public_path__ + "static/media/appInfo2.567d20bc.png";